import React, { Component } from 'react'
import { Form } from '@ant-design/compatible'
import '@ant-design/compatible/assets/index.css'
import 'antd4/lib/grid/style/index.css'

import { Tabs, Checkbox, Radio, Input, Row, Col } from 'hljd'
import { observer, inject } from 'mobx-react'
import Style from './style.module.less'
import _toString from 'lodash/toString'

const TabPane = Tabs.TabPane

@Form.create()
@inject('addCustomerStore')
@observer
export default class Questionnaire extends Component {
  constructor() {
    super()
    this.checkbox_extra = {}
    this.radio_extra = {}
  }

  componentDidMount() {
    this.props.addCustomerStore.questionDrawerStore.getFunc(
      'form',
      this.props.form
    )
  }

  renderQuestions = (current_budget, answers = []) => {
    const { questions = [], property_id } = current_budget

    return questions.map(item => {
      const { title, iseq } = item
      const answer_info = answers.find(answer => answer.question_id == item.id)
      //console.log(answer_info, item)
      const answer = answer_info
        ? answer_info.content
          ? answer_info.content
          : answer_info.answer
        : ''
      return (
        <Row key={item.id} style={{ marginBottom: 20 }}>
          <Col style={{ marginBottom: 10 }}>{`${iseq}.${title}`}</Col>
          <Col>{this.renderItem(item, property_id, answer)}</Col>
        </Row>
      )
    })
  }

  renderItem = (question, property_id, answer) => {
    const { getFieldDecorator } = this.props.form
    const { setInputVal } = this.props.addCustomerStore.questionDrawerStore
    switch (_toString(question.type)) {
      case '1': //多选
        const vals = answer
          ? answer.map(item => `${item.option_id}_${item.name}`)
          : []
        const input_value = answer ? answer.find(item => item.text) : {}
        return (
          <div>
            {getFieldDecorator(`checkbox_${question.id}`, {
              initialValue: vals || []
            })(
              <Checkbox.Group>
                {question.options
                  .filter(val => val.is_custom == 0)
                  .map(item => (
                    <Checkbox value={`${item.id}_${item.name}`} key={item.id}>
                      {item.name}
                    </Checkbox>
                  ))}

                {question.options
                  .filter(val => val.is_custom == 1)
                  .map(item => {
                    //获取初始值
                    if (
                      !this.checkbox_extra[
                        `text_${question.id}_${item.id}_checkbox`
                      ] &&
                      input_value &&
                      input_value.text
                    ) {
                      setInputVal(
                        `text_${question.id}_${item.id}_checkbox`,
                        this.checkbox_extra,
                        input_value.text
                      )()
                    }

                    return (
                      <span
                        style={{ whiteSpace: 'nowrap', paddingLeft: 0 }}
                        key={item.id}
                      >
                        <Checkbox
                          value={`${item.id}_${item.name}`}
                          key={item.id}
                        >
                          {item.name}
                        </Checkbox>
                        <span>
                          <span>{`：`}</span>
                          {getFieldDecorator(
                            `text_${question.id}_${item.id}_checkbox`,
                            {
                              initialValue: input_value ? input_value.text : ''
                            }
                          )(
                            <Input
                              style={{ width: 180 }}
                              onChange={setInputVal(
                                `text_${question.id}_${item.id}_checkbox`,
                                this.checkbox_extra
                              )}
                            />
                          )}
                        </span>
                      </span>
                    )
                  })}
              </Checkbox.Group>
            )}
          </div>
        )
      case '0': //单选
        const val = answer ? `${answer[0].option_id}_${answer[0].name}` : ''
        const text = answer ? answer[0].text : ''
        return (
          <div>
            {getFieldDecorator(`radio_${question.id}`, {
              initialValue: val || ''
            })(
              <Radio.Group>
                {question.options
                  .filter(val => val.is_custom == 0)
                  .map(item => (
                    <Radio value={`${item.id}_${item.name}`} key={item.id}>
                      {item.name}
                    </Radio>
                  ))}
                {question.options
                  .filter(val => val.is_custom == 1)
                  .map(item => {
                    //获取初始值
                    if (
                      !this.radio_extra[
                        `text_${question.id}_${item.id}_radio`
                      ] &&
                      text
                    ) {
                      setInputVal(
                        `text_${question.id}_${item.id}_radio`,
                        this.radio_extra,
                        text
                      )()
                    }

                    return (
                      <span key={item.id} style={{ whiteSpace: 'nowrap' }}>
                        <Radio value={`${item.id}_${item.name}`} key={item.id}>
                          {item.name}
                        </Radio>
                        <span>{`：`}</span>
                        {getFieldDecorator(
                          `text_${question.id}_${item.id}_radio`,
                          {
                            initialValue: text || ''
                          }
                        )(
                          <Input
                            style={{ width: 180 }}
                            onChange={setInputVal(
                              `text_${question.id}_${item.id}_radio`,
                              this.radio_extra
                            )}
                          />
                        )}
                      </span>
                    )
                  })}
              </Radio.Group>
            )}
          </div>
        )
      case '2': //文本
        return <Row>{this.renderText(question, getFieldDecorator, answer)}</Row>
    }
  }

  renderText = (question, getFieldDecorator, answer) => {
    if (question.options.length) {
      return question.options.map(item => {
        const val = answer ? answer.find(val => val.option_id == item.id) : {}
        return (
          <Col span={12} key={item.id}>
            <span>{item.name}：</span>
            {getFieldDecorator(
              `text_${question.id}_${item.id}_and_${item.name}`,
              {
                initialValue: val ? val.text : ''
              }
            )(<Input style={{ width: 180 }} />)}
          </Col>
        )
      })
    } else {
      const val = answer ? answer[0] : {}
      return (
        <span key={question.id}>
          {getFieldDecorator(`text_${question.id}`, {
            initialValue: val ? val.text : ''
          })(<Input style={{ width: 180 }} />)}
        </span>
      )
    }
  }

  render() {
    const {
      budgetList,
      questionDrawerStore: { current_budget, survey }
    } = this.props.addCustomerStore

    const _survey = survey.find(
      item => item.property_id == current_budget.property_id
    )
    const answers = _survey ? _survey.answers : []
    //console.log(toJS(answers))

    return (
      <div className={Style.survey}>
        <Tabs
          tabPosition="bottom"
          activeKey={_toString(current_budget.property_id)}
        >
          {budgetList.map(item => {
            return (
              <TabPane tab="" key={item.id || item.property_id}>
                {current_budget &&
                  this.renderQuestions(current_budget, answers)}
              </TabPane>
            )
          })}
        </Tabs>
      </div>
    )
  }
}
